export const BRAND_LOGO_SITUATIONS = [
    'default',
    'dark_background',
    'light_background',
    'email',
    'social',
    'co_branding',
    'print',
    'favicon',
];
export const BRAND_LOGO_SITUATION_LABELS = {
    default: 'Standaard',
    dark_background: 'Donkere achtergrond',
    light_background: 'Lichte achtergrond',
    email: 'E-mail / handtekening',
    social: 'Social media',
    co_branding: 'Co-branding',
    print: 'Print / PDF',
    favicon: 'Favicon / klein icoon',
};
//# sourceMappingURL=brandLogoSituations.js.map